import React from "react";
import { Link, Outlet, useLocation, Navigate } from "react-router-dom";
import useUserStore from "../../store/userStore";
import { useTranslation } from "../../i18n/useTranslation";
import { cn } from "../../lib/utils";
import Footer from "../../components/Footer";

const navItems = [
  { path: "/account/overview", key: "accountOverview" },
  { path: "/account/subscription", key: "accountSubscription" },
  { path: "/account/devices", key: "accountDevices" },
  { path: "/account/security", key: "accountSecurity" },
];

const AccountLayout = () => {
  const { isLoggedIn } = useUserStore();
  const location = useLocation();
  const { t } = useTranslation();

  if (!isLoggedIn) {
    return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname || "/account/overview")}`} replace />;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <main className="flex-1 container mx-auto px-4 py-8 pt-24">
        <div className="flex flex-col md:flex-row gap-8">
          <nav className="md:w-52 flex-shrink-0">
            <ul className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
              {navItems.map(({ path, key }) => (
                <li key={path}>
                  <Link
                    to={path}
                    className={cn(
                      "block px-4 py-3 text-sm border-b border-gray-100 last:border-b-0",
                      location.pathname === path
                        ? "bg-[#e6f7ff] text-[#004b67] font-medium"
                        : "text-gray-600 hover:bg-gray-50"
                    )}
                  >
                    {t(key)}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
          <div className="flex-1 min-w-0">
            <Outlet />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AccountLayout;
